import { useLocation, useNavigate, useParams } from "react-router-dom";
import { SECTION_PATH } from "../../../../../path";
import { pathToSS } from "../../../util";
import MultiScanner from "./MultiScanner";

type Props = {
  count: number;
  match: number;
};

const MultiScannerCard = ({ count, match }: Props) => {
  const { hash = "", sourceId = "" } = useParams();
  const navigate = useNavigate();
  const { search } = useLocation();

  const handleSectionClick = () => {
    if (!match) return;
    const path = pathToSS(hash, sourceId, SECTION_PATH.SAMPLE_DETAILS_TICLOUD);
    navigate(`${path}${search}`);
  };

  return (
    <MultiScanner
      className={match ? "cursor-pointer" : ""}
      count={count}
      match={match}
      onClick={handleSectionClick}
    />
  );
};

export default MultiScannerCard;
